module.exports = __webpack_public_path__ + "img/quest_icon_0007_death.5f6221bd.png";